import "./SinglePostTemplate.module.css"
import WebsiteHeader from "@/reusable_sections/Header"
import SinglePostTemplateSection from "./sections/SinglePostTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <WebsiteHeader />
      <SinglePostTemplateSection />
      <Footer />
    </div>
  )
}
